import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AppMainService } from 'src/app/app-main.service';
import { AccountServiceN } from '../../services/account.services';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { StageN } from '../../models/stage.model';

@Component({
  selector: 'app-make-account-copy',
  templateUrl: './make-account-copy.component.html',
  styleUrls: ['./make-account-copy.component.scss']
})
export class MakeAccountCopyComponent implements OnInit {

  
  @Input() displayCopyAccountDialog:boolean;
  @Input() allAccountChannelListForCopy: any;
  @Input() display: any;
  selectedAccountChannelForCopy: any;
  
  @Output() selectedAccountChannelIdForCopy = new EventEmitter<any>();
  @Output() openAddForCopy = new EventEmitter<any>();
  @Output() cancelCopyAccountModal = new EventEmitter<any>();
  @Output() saveCopyAccountModal = new EventEmitter<any>();

  selectStageForCopy: any = "";

  stagesCountN: StageN[] = [];
  pageNumber: number = 1;
  pageSize: number = 15;
  first: number = 0;
  isActive: boolean = true;

  private ngUnsubscribe = new Subject<void>();

  constructor(
    public appMainService: AppMainService,
    private accountServiceN: AccountServiceN,
    private messageService: MessageService,
  ) {}
      ngOnInit(): void {
      }

      ngOnChanges(changes: SimpleChanges): void
      {
          if (changes?.displayCopyAccountDialog?.currentValue) {
            this.displayCopyAccountDialog = changes.displayCopyAccountDialog.currentValue;
          } 

          if (changes?.display?.currentValue) {
            this.display = changes.display.currentValue;
          } 
      }

      
  onChannelChange() {
    this.selectStageForCopy = null;
    this.getChannelStage();
  }

      getChannelStage(): void {
        this.appMainService.isShowSpinner('getStages');
        this.accountServiceN.getStages(this.selectedAccountChannelForCopy?.id, true, null)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
            next: (response) => {
                      this.stagesCountN = response?.length ? response.filter(c => c.id) : [];
                      this.appMainService.isHideSpinner('getStages');
            },
            error: (error) => {
                    this.appMainService.isHideSpinner('getStages');
                    this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.Message : 'Stages are not loaded, please try again...'
              });
            }
          });
      }

      cancelCopyAccount() {
        this.selectedAccountChannelForCopy= null;
        this.selectStageForCopy= " ";
        this.cancelCopyAccountModal.emit();
      }
    
      nextMethod(){
          this.selectedAccountChannelIdForCopy.emit({accountChannel: this.selectedAccountChannelForCopy,
          businessClassification: this.selectStageForCopy, stagesForCopy: this.stagesCountN});
          this.selectedAccountChannelForCopy= null;
          this.openAddForCopy.emit();
          this.selectStageForCopy= " ";
      }
      ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
      }
    }


